import { Input as MantineInput } from '@mantine/core';
import inputWrapperStyles from '../styles/Input.module.css';
import { FC } from 'react';

export type MantineInputDescriptionProps = React.ComponentProps<typeof MantineInput.Description>;

export const InputDescription: FC<MantineInputDescriptionProps> = props => {
    return (
        <MantineInput.Description
            classNames={{
                description: inputWrapperStyles.description,
            }}
            {...props}
        />
    );
};
